import React from "react";
import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useSurrender from "./useSurrender";

const Surrender = () => {
  const { drawerMenu } = useSurrender();
  return (
    <CommonLayout drawerMenu={drawerMenu}  >
      <Outlet />
    </CommonLayout>
  );
};

export default Surrender;
